// src/components/TopBanner.js
import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import {
  getTopBannerMessages,
  getTopBannerSettings,
} from "../services/topBanner.api";

const sanitizeEtikaBannerMessage = (value) =>
  String(value || "")
    .replace(/velle\s*shop/gi, "ETIKA")
    .replace(/\bvelle\b/gi, "ETIKA");

function TopBanner() {
  const { lang } = useContext(LanguageContext);

  const [messages, setMessages] = useState([]);
const [bannerColor, setBannerColor] = useState("");

  useEffect(() => {
  let mounted = true;

  getTopBannerMessages()
    .then((rows) => {
      if (!mounted) return;

      const safeRows = Array.isArray(rows) ? rows : [];

      setMessages(
        safeRows
          .map((r) =>
            sanitizeEtikaBannerMessage(
              lang === "EN" ? r.message_en : r.message_ar
            )
          )
          .filter((msg) => String(msg || "").trim().length > 0)
      );

      setIndex(0);
      setFade(true);
    })
    .catch(() => {
      if (mounted) {
        setMessages([]);
      }
    })

  return () => {
    mounted = false;
  };
}, [lang]);

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
  if (messages.length <= 1) return;

  const timer = setInterval(() => {
    setFade(false);

    const fadeTimer = setTimeout(() => {
      setIndex((prev) => (prev + 1) % messages.length);
      setFade(true);
    }, 300);

    return () => clearTimeout(fadeTimer);
  }, 4000);

  return () => clearInterval(timer);
}, [messages.length]);

  useEffect(() => {
  let mounted = true;

  getTopBannerSettings()
    .then((settings) => {
      if (!mounted) return;
      setBannerColor(settings?.background_color || "");
    })
    .catch(() => {
      if (mounted) setBannerColor("");
    })

  return () => {
    mounted = false;
  };
}, []);

  const currentMessage = messages[index] || "";
  const hasMessage = currentMessage.trim().length > 0;
  const messageLines = String(currentMessage).split(/\r?\n/);
  const firstLine = messageLines[0] || "";
  const secondLine = messageLines.slice(1).join(" ");


  return (
  <div
    className="
      w-full
      min-h-[60px] md:min-h-[46px]
      px-3 py-4 md:py-2
      flex items-center justify-center
      text-center relative overflow-hidden
    "
    style={{
      background: bannerColor
  ? bannerColor
  : "linear-gradient(90deg, #111111, #3a3a3a, #111111)",
backgroundSize: bannerColor ? "auto" : "220% 220%",
animation: "none",
      color: "#ffffff",
    }}
  >
    {/* MOBILE - unchanged behavior */}
    <span
      className={`
        md:hidden
        inline-flex items-center justify-center gap-2 font-semibold
        transition-all duration-500
        ${fade ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1"}
      `}
      style={{
        fontSize: lang === "AR" ? "13px" : "12px",
        direction: lang === "AR" ? "rtl" : "ltr",
        textShadow: "0px 2px 10px rgba(0, 0, 0, 0.25)",
      }}
    >
      <span
        className="block text-center"
        style={{
          whiteSpace: "pre-line",
          lineHeight: "1.35",
        }}
      >
        {hasMessage
  ? currentMessage
  : lang === "AR"
  ? "مرحباً بكم في ETIKA"
: "Welcome to ETIKA"}
      </span>
    </span>

    {/* DESKTOP - custom layout */}
    <div
      className={`
        hidden md:flex
        w-full h-full
        items-center justify-center
        font-semibold
        transition-all duration-500
        ${fade ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1"}
      `}
      style={{
        direction: lang === "AR" ? "rtl" : "ltr",
        textShadow: "0px 2px 10px rgba(0, 0, 0, 0.25)",
      }}
    >
      {/* FIRST LINE CENTER */}
      <span
        className="block text-center"
        style={{
          fontSize: "16px",
          lineHeight: "1.25",
        }}
      >
        {hasMessage
  ? firstLine
  : lang === "AR"
  ? "مرحباً بكم في ETIKA"
: "Welcome to ETIKA"}
      </span>

      {/* SECOND LINE TOP RIGHT */}
      {secondLine && (
        <span
          className="absolute top-1 right-6 text-right"
          style={{
            fontSize: "16px",
            lineHeight: "1.25",
          }}
        >
          {secondLine}
        </span>
      )}
    </div>
  </div>
);
}

export default TopBanner;